import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import './DashboardLayout.css';

const DashboardLayout: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [previousWidth, setPreviousWidth] = useState(window.innerWidth);

  const handleSidebarToggle = () => {
    const isMobile = window.innerWidth <= 1024;

    if (isMobile) {
      setIsMobileSidebarOpen(!isMobileSidebarOpen);
    } else {
      setIsSidebarCollapsed(!isSidebarCollapsed);
    }
  };

  // Handle window resize - only close sidebar when transitioning from mobile to desktop
  useEffect(() => {
    const handleResize = () => {
      const currentWidth = window.innerWidth;
      const wasMobile = previousWidth <= 1024;
      const isMobile = currentWidth <= 1024;

      // Only close mobile sidebar if we're transitioning from mobile to desktop
      if (wasMobile && !isMobile && isMobileSidebarOpen) {
        setIsMobileSidebarOpen(false);
      }

      setPreviousWidth(currentWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [previousWidth, isMobileSidebarOpen]);

  // Close mobile sidebar when clicking outside
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      const target = event.target as Element;
      if (isMobileSidebarOpen && !target.closest('.sidebar') && !target.closest('.header__menu-toggle')) {
        setIsMobileSidebarOpen(false);
      }
    };

    if (isMobileSidebarOpen) {
      document.addEventListener('click', handleOutsideClick);
      return () => document.removeEventListener('click', handleOutsideClick);
    }
  }, [isMobileSidebarOpen]);

  return (
    <div className="dashboard-layout">
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        onToggle={handleSidebarToggle}
      />

      <div
        className={`dashboard-layout__sidebar-mobile ${isMobileSidebarOpen ? 'dashboard-layout__sidebar-mobile--open' : ''}`}
      >
        <Sidebar
          isCollapsed={false}
          onToggle={handleSidebarToggle}
        />
      </div>

      {isMobileSidebarOpen && (
        <div
          className="dashboard-layout__overlay"
          onClick={() => setIsMobileSidebarOpen(false)}
        />
      )}

      <Header
        isSidebarCollapsed={isSidebarCollapsed}
        onSidebarToggle={handleSidebarToggle}
      />

      <main
        className={`dashboard-layout__main ${isSidebarCollapsed ? 'dashboard-layout__main--sidebar-collapsed' : ''
          }`}
      >
        <div className="dashboard-layout__content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;